import {
  useElements,
  useStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import React, { useState, useEffect } from "react";
import axios from "axios";
import ApiService from "../api";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import 'bootstrap/dist/css/bootstrap.css';
import "../../scss/Modal.scss";
import { BASE_URL } from "../../config.json";

const Modal = ({ show, close, title, children }) => {
  return (
    <>
      {show ? (
        <div className="modalContainerasfdfasdfasdfasd" onClick={() => close()}>
          <div
            className="modalasdfasdfasdfasdfasdf"
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#ffffff" }}
          >
            <header className="modal_header">
              <h2 className="modal_header-title">{title}</h2>
              <button
                className="close"
                onClick={() => close()}
                style={{ fontSize: "26px" }}
              >
                ✕
              </button>
            </header>
            <main className="modal_content"> {children} </main>
          </div>
        </div>
      ) : null}
    </>
  );
};

const CheckoutForm = (props) => {
  const [error, setError] = useState(false);

  const [Type, setType] = useState("");

  const [NameOnCard, setNameOnCard] = useState("");
  const [NameNumber, setNameNumber] = useState("");
  const [ExpiryDate, setExpiryDate] = useState("");
  const [CV2, setCV2] = useState("");

  const [ClubId, setClubId] = useState("");
  const [Address1, setAddress1] = useState("");
  const [Address2, setAddress2] = useState("");
  const [Town, setTown] = useState("");
  const [County, setCounty] = useState("");
  const [Country, setCountry] = useState("");

  const [PostCode, setPostCode] = useState("");
  const [BillingAddSame, setBillingAddSame] = useState(false);
  const [AgreementBTN, setAgreementBTN] = useState(false);
  const [TotalAmountToPay, setTotalAmountToPay] = useState("");
  const [subscription, setSubscription] = useState("");

  const [email, setEmail] = useState("");
  const [totalCourse, setTotalCourse] = useState("");
  const [subscription_id, setSubscriptionId] = useState("2");

  const [suggestionList, setSuggestionList] = useState([]);
  const [activeSuggestion, setActiveSuggestion] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [userInput, setUserInput] = useState();

  const [submit, setSubmit] = useState(false);
  const [errors, setErrors] = useState({});
  const [isCardValid, setIsCardValid] = useState(false);
  const [isMonthValid, setIsMonthValid] = useState(false);
  const [isCVCValid, setIsCVCValid] = useState(false);

  const [StaticTCAPIDATA, setStaticTCAPIDATA] = useState("");

  const [modal, setModal] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const validate = () => {
    console.log(submit, "submit");
    if (submit) {
      let errors = {};
      if (!Address1) {
        errors.address = "Required";
      }

      if (!Town) {
        errors.town = "Required";
      }

      if (!County) {
        errors.county = "Required";
      }

      if (!PostCode) {
        errors.postcode = "Required";
      }
      if (!AgreementBTN) {
        errors.agreementBTN = "Required";
      }
      setErrors(errors);
    }

    console.log(errors, "errors");
  };

  const Cancel = () => {
    setModalIsOpen(true);
  };
  const Toggle = () => setModal(!modal);

  const stripe = useStripe();
  const elements = useElements();

  const courseValueMonthly = 4.575;

  let history = useHistory();

  const makeAPICallToFetchTCDATA = () => {
    axios
      .get(`${BASE_URL}/terms_condition/`)
      .then((resp) => {
        setStaticTCAPIDATA(resp.data.data[0].description);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    makeAPICallToFetchTCDATA();
    ApiService.getSubscriptionDetails().then((res) => {
      // console.log(res);
      setSubscription(res.data.data);
      setTotalAmountToPay({
        amount:
          res.data.data.find((_s) => _s.id === 2).amount.toFixed(2) *
          props.Data.users.length,
        type: "yearly",
      });
      console.log(subscription);
    });
    return () => (document.body.style.overflow = "unset");
  }, []);

  useEffect(() => {
    if (modal) document.body.style.overflow = "hidden";
    if (!modal) document.body.style.overflow = "unset";
  }, [modal]);

  // Handle real-time validation errors from the CardElement.
  const handleChange = (event) => {
    let temp_elementType = `${event.elementType.substr(
      0,
      4
    )} ${event.elementType.substr(4)}`;

    if (event.error) {
      setError({ elementType: temp_elementType, error: event.error.message });
    } else if (!event.complete) {
      setError({
        elementType: temp_elementType,
        error: `Your ${temp_elementType} is incomplete`,
      });
    }

    if (temp_elementType === "card Number") {
      event.complete ? setIsCardValid(true) : setIsCardValid(false);
    } else if (temp_elementType === "card Expiry") {
      event.complete ? setIsMonthValid(true) : setIsMonthValid(false);
    } else if (temp_elementType === "card Cvc") {
      event.complete ? setIsCVCValid(true) : setIsCVCValid(false);
    }

    // setNameNumber(event.target.value);
  };

  useEffect(() => {
    if (isCardValid && isCVCValid && isMonthValid) {
      setError(null);
    } else if (!isCardValid || !isCVCValid || !isMonthValid || !error) {
      setError({ ...Error, error: "* Required" });
    }
  }, [isCardValid, isCVCValid, isMonthValid]);

  // Handle form submission.
  const handleSubmit = async (event) => {
    event.preventDefault();
    validate();
    let objFlag = false;
    for (let key in TotalAmountToPay) {
      if (key == "type") {
        objFlag = true;
      }
    }
    console.log(AgreementBTN, isMonthValid, isCVCValid);
    if (
      AgreementBTN === true &&
      isCardValid === true &&
      isMonthValid === true &&
      isCVCValid === true &&
      Town.length >= 1 &&
      PostCode.length > 2 &&
      objFlag &&
      TotalAmountToPay.type.length > 2
    ) {
      if (!error) {
        const card = elements.getElement(CardNumberElement);
        props.changeSpinner(true);
        // add these lines
        const { paymentMethod, error } = await stripe.createPaymentMethod({
          type: "card",
          card: card,
        });

        let localStorageVal_ClubDetails = JSON.parse(
          localStorage.getItem("Create-ClubDetail")
        );
        // For Renew Subscription in the club
        if (props.renewPay) {
          let strip_payload_param = {
            payment_details: {
              payment_method_id: paymentMethod.id,
              subscription_id: subscription_id,
            },
            billing_address: {
              id: ClubId,
              address1: Address1,
              address2: Address2,
              town: Town,
              county: County,
              post_code: PostCode,
              country: Country,
            },
          };

          ApiService.saveRenewStripeInfo(strip_payload_param)
            .then((res) => {
              props.changeSpinner(false);
              history.push("/billing");
              toast.success("Account Renewed SuccessFully");
            })
            .catch(() => {
              toast.error("Unable to Renewal Account");
            });
        }

        // For First Time Payment on registering the club
        else {
          let strip_payload_param = {
            payment_method_id: paymentMethod.id,
            subscription_id: subscription_id,
            totalCourse: TotalAmountToPay["amount"],
            billing_details: { email: "", name: "", phone: "" },
            address: {
              city: "",
              country: "",
              line1: "",
              line2: "",
              state: "",
              postal_code: "",
            },
          };

          strip_payload_param["billing_details"]["email"] =
            localStorageVal_ClubDetails.email;
          strip_payload_param["billing_details"]["name"] =
            localStorageVal_ClubDetails.name;
          strip_payload_param["billing_details"]["phone"] =
            localStorageVal_ClubDetails.phone;
          strip_payload_param["address"]["city"] = Town;
          strip_payload_param["address"]["country"] = County;
          strip_payload_param["address"]["line1"] = Address1;
          strip_payload_param["address"]["line2"] = Address2;
          strip_payload_param["address"]["state"] = "";
          strip_payload_param["address"]["postal_code"] = PostCode;
          debugger;
          ApiService.saveStripeInfo(strip_payload_param)
            .then((response) => {
              console.log(response, "from checkout form");
              console.log(response.data, response.status);
              props.changeSpinner(false);

              const registerationInfo = JSON.parse(
                localStorage.getItem("Create-ClubDetail")
              );

              // Clear all of the local storage values
              localStorage.removeItem("Create-ClubDetail");
              localStorage.removeItem("Create-GolfCourse");
              // pass the reference id after succesful payment from here
              // history.push({ pathname: "/pay-confirm", state: { reference_id: response.data.reference_id } });
              toast.success("Club registered successfully!");
              if ("SetScreenPostion" in props && "Setreference_id" in props) {
                props.SetScreenPostion(4);
                props.Setreference_id({
                  reference_id: response.data.reference_id,
                });
                console.log("Renew Membership");
              } else {
                history.push({
                  pathname: "/pay-confirm",
                  state: {
                    reference_id: response.data.id,
                    invoice_file_url: response.data.data.invoice_file_url,
                    regDetails: registerationInfo,
                  },
                });
                console.log("Registration");
              }
            })
            .catch((error) => {
              if (error) {
                let errObj = error.response.data.array_error;
                // toast.error(error.response.data.errMsg.toUpperCase());
                // toast.error(...errObj[Object.keys(errObj)[0]]);
                props.changeSpinner(false);
              }
            });
        }
      }
    } else {
      console.error(
        "Please agree T&C / Valid card deatils / Select subscription type / Billing address"
      );
    }
  };

  const populateBillingAddress = () => {
    if (props.renewPay) {
      let localStorageVal_ClubDetails_func = JSON.parse(
        localStorage.getItem("Renew-BillingAddress")
      );
      setClubId(localStorageVal_ClubDetails_func.id);
      setCountry(localStorageVal_ClubDetails_func.country);
      if (BillingAddSame) {
        setAddress1(localStorageVal_ClubDetails_func.address1);
        setAddress2(localStorageVal_ClubDetails_func.address2);
        setTown(localStorageVal_ClubDetails_func.town);
        setCounty(localStorageVal_ClubDetails_func.county);
        setPostCode(localStorageVal_ClubDetails_func.post_code);
      } else {
        setAddress1("");
        setAddress2("");
        setTown("");
        setCounty("");
        setPostCode("");
      }
    } else {
      let localStorageVal_ClubDetails_func = JSON.parse(
        localStorage.getItem("Create-ClubDetail")
      );
      if (BillingAddSame) {
        setAddress1(localStorageVal_ClubDetails_func.address);
        setAddress2(localStorageVal_ClubDetails_func.address2);
        setTown(localStorageVal_ClubDetails_func.town);
        setCounty(localStorageVal_ClubDetails_func.county);
        setPostCode(localStorageVal_ClubDetails_func.postcode);
      } else {
        setAddress1("");
        setAddress2("");
        setTown("");
        setCounty("");
        setPostCode("");
      }
    }
  };

  useEffect(() => {
    validate();
  }, [Address1, AgreementBTN, PostCode]);

  // BillingAddSame
  useEffect(() => {
    populateBillingAddress();
  }, [BillingAddSame]);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const renderSuggestions = () =>
    suggestionList.map((item, index) => {
      const { Id, Description, Text } = item;

      let activeClass;
      if (index === activeSuggestion) {
        activeClass = "suggestion-active";
      }

      // console.log(Id, Text, Description);

      return (
        <li
          className={
            activeClass === "suggestion-active"
              ? "suggestion-active"
              : "suggestion"
          }
          onClick={(e, item) => {
            handleClick(e, Id, Description);
          }}
          key={Id}
        >
          <strong>
            <small>{`${Text}, ${Description}`}</small>
          </strong>
        </li>
      );
    });

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      setActiveSuggestion(0);
      setShowSuggestions(false);
      const selectedInput = suggestionList[activeSuggestion];
      console.log(selectedInput, "selected");
      // const fll_address = `${selectedInput.Line2} ${selectedInput.Line3}`
      // setUserInput(selectedInput);
      // setAddress1(selectedInput.Line1);
      // setAddress2(fll_address);
      // setTown(selectedInput.City);
      // setCounty(selectedInput.Province);
      // setPostCode(selectedInput.PostalCode);
    } else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }
      setActiveSuggestion(activeSuggestion - 1);
      console.log(activeSuggestion, "activesuggestion");
    } else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === suggestionList.length) {
        return;
      }
      setActiveSuggestion(activeSuggestion + 1);
    }
  };

  const retrieveAddress = (Key, Id) => {
    var Field1Format = "";
    var url =
      "https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.00/json3.ws";
    var params = "";
    params += "&Key=" + encodeURIComponent(Key);
    params += "&Id=" + encodeURIComponent(Id);
    params += "&Field1Format=" + encodeURIComponent(Field1Format);

    console.log(params, "parameters");

    axios
      .post(url, params, {
        "Content-type": "application/x-www-form-urlencoded",
      })
      .then((res) => {
        console.log(res);
        const fll_address = res.data.Items[0];
        let address_line1 = fll_address.Label.split("\n").at(0);
        let address_line2 = fll_address.Line1;

        if (address_line1 === address_line2) {
          address_line1 = address_line1.split(" ").at(0);
          address_line2 = address_line2.split(" ").at(1);
        }
        setAddress1(address_line1);
        setAddress2(address_line2);
        setTown(fll_address.City);
        setCounty(fll_address.Province);
        setPostCode(fll_address.PostalCode);
      });
  };

  const HandleChange = (e, secondFind) => {
    setShowSuggestions(true);
    setAddress1(e.target.value);
    setUserInput(userInput);
    setSuggestionList([]);

    let Text = e.target.value;
    let Container = "";

    if (secondFind !== undefined) {
      Container = secondFind;
      Text = Address1;
    }

    const Key = "NH12-UF93-HD94-AB92",
      IsMiddleware = false,
      Origin = "",
      Countries = "GB",
      Limit = "15",
      Language = "en-us",
      url1 =
        "https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3.ws";
    var params = "";
    params += "&Key=" + encodeURIComponent(Key);
    params += "&Text=" + encodeURIComponent(Text);
    params += "&IsMiddleware=" + encodeURIComponent(IsMiddleware);
    params += "&Container=" + encodeURIComponent(Container);
    params += "&Origin=" + encodeURIComponent(Origin);
    params += "&Countries=" + encodeURIComponent(Countries);
    params += "&Limit=" + encodeURIComponent(Limit);
    params += "&Language=" + encodeURIComponent(Language);

    if (Text.length >= 3) {
      axios
        .post(url1, params, {
          "Content-type": "application/x-www-form-urlencoded",
        })
        .then(({ data }) => {
          const items = data.Items;
          console.log(items, "items");
          // console.log(item);
          setSuggestionList(items);
          // console.log(suggestionList,"Suggestion List");
        })
        .catch((err) => console.log(err));
    }
  };

  const handleClick = async (e, Id, Description) => {
    const fullAddress = e.currentTarget.innerText.split(",");
    console.log(Id, "Item");
    const Key = "NH12-UF93-HD94-AB92";

    if (Description.includes("Addresses")) {
      HandleChange(e, Id);
    } else {
      retrieveAddress(Key, Id);
      setShowSuggestions(false);
      setSuggestionList([]);
      setActiveSuggestion(0);
    }
    // console.log(Key, Id, Description, "item data");

    // retrieveAddress(Key, Id);
  };

  // Get Subscription Details

  return (
    <>
      <form
        onSubmit={(e) => {
          setSubmit(true);
          handleSubmit(e);
        }}
        className="stripe-form"
      >
        <ToastContainer />
        <div className="cpay__box">
          <div className="cpay__box__left">
            <h2 className="cpay__box__left-txt text-jost-sb-22">
              Payment method
            </h2>
            <div className="cpay__box__left-card">
              {/* <input className="cardpay" id="" type="radio" name="payment" />
              <div className="footer__nav-check">
                                <input type="radio" id="pay_agree" name="payment" value=""/>
                                <label htmlFor="pay_agree" className="checkmark_ft"></label>

                            </div>
             
              {"Stripe Checkout"} */}
              <img
                src={require("../../assets/images/card/card_1.svg").default}
                alt=""
              />
              <img
                src={require("../../assets/images/card/card_2.svg").default}
                alt=""
              />
              <img
                src={require("../../assets/images/card/card_3.svg").default}
                alt=""
              />
            </div>
            <div className="cpay__box__left-cdetail">
              <div className="cpay__box__left-cname">
                <label htmlFor="" className="text-jost-sb-19">
                  Enter Card Details*
                </label>
                <div className="card-detail errors_container">
                  {/*<CardElement*/}
                  {/*    className="form__input-md"*/}
                  {/*    type="text"*/}
                  {/*    required*/}
                  {/*    id="card-element"*/}
                  {/*    onChange={handleChange}*/}
                  {/*    options={{*/}
                  {/*        style: {*/}
                  {/*            base: {*/}
                  {/*                ':focus': {*/}
                  {/*                    color: "white",*/}
                  {/*                    fontSize:"1rem"*/}
                  {/*                },*/}
                  {/*            },*/}
                  {/*            complete: {*/}
                  {/*                color: "white"*/}
                  {/*            }*/}
                  {/*        },*/}
                  {/*        hidePostalCode: true*/}
                  {/*    }}*/}
                  {/*/>*/}
                  <CardNumberElement
                    className="form__input-md"
                    type="text"
                    required
                    id="card-element"
                    onChange={handleChange}
                    options={{
                      style: {
                        base: {
                          fontSize: "1.8rem",
                          height: "40px",
                          ":focus": {
                            color: "black",
                            fontSize: "1.8rem",
                            
                          },
                          "::placeholder": {
                            fontSize: "1.8rem",
                            textIndent: "20px",
                          },
                        },
                        complete: {
                          color: "#13320C",
                        },
                      },
                    }}
                  />
                  <div className="card-date">
                    <CardExpiryElement
                      className="form__input-md"
                      type="text"
                      required
                      id="card-element"
                      onChange={handleChange}
                      options={{
                        style: {
                          base: {
                            fontSize: "1.8rem",
                            ":focus": {
                              color: "#13320C",
                              fontSize: "1.8rem",
                            },
                          },
                          complete: {
                            color: "#13320C",
                          },
                        },
                      }}
                    />
                    <CardCvcElement
                      className="form__input-md"
                      type="text"
                      required
                      id="card-element"
                      onChange={handleChange}
                      options={{
                        style: {
                          base: {
                            fontSize: "1.8rem",
                            ":focus": {
                              color: "#13320C",
                              fontSize: "1.8rem",
                            },
                          },
                          complete: {
                            color: "#13320C",
                          },
                        },
                      }}
                    />
                  </div>

                  <div
                    className="errors"
                    role="alert"
                    style={{ width: "30vw", color: "red" }}
                  >
                    {error?.error ||
                      ((!isCardValid || !isMonthValid || !isCVCValid) && submit
                        ? "*Required"
                        : null)}
                  </div>
                </div>
                {/* <div className="cpay__box__left__cdetail-warn">
                                <a href="">
                                    <img src={require("../../assets/images/warning/warning_pay.svg").default}
                                        alt="" />
                                    What is this? </a>
                            </div> */}
              </div>
              {/*  <div className="cpay__box__left__cdetail">
                        <div className="cpay__box__left__cdetail-cnum">
                            <label htmlFor="" className="label__set">Name Number*</label>
                            <input className="form__input-md" type="text" placeholder="" name="" value={NameOnCard}  onChange={(event) => { setNameOnCard(event.target.value) }} required />
                        </div>
                        <div className="cpay__box__left__cdetail-edate">
                            <label htmlFor="" className="label__set">Expiry Date</label>
                            <input className="form__input-md" type="text" placeholder="" name="" value={ExpiryDate}  onChange={(event) => { setExpiryDate(event.target.value) }} required />
                        </div>
                        <div className="cpay__box__left__cdetail-cvv">
                            <label htmlFor="" className="label__set">CV2</label>
                            <input className="form__input-md" type="text" placeholder="" name="" value={CV2}  onChange={(event) => { setCV2(event.target.value) }} required />
                        </div>
                    </div> */}
            </div>

            <div className="cpay__box__left__check">
              <input
                className={`checkbox-styling ${BillingAddSame}-checked`}
                name="bill_add"
                id="bill_add"
                type="checkbox"
                checked={BillingAddSame}
                onChange={(event) => {
                  setBillingAddSame(event.target.checked);
                }}
              />
              <label
                htmlFor="bill_add"
                className={`checkbox ${BillingAddSame}-checked`}
              ></label>
              <span className="text-jost-sb-19">
                Billing details are the same as Club Address
              </span>
            </div>
            <div className="cpay__box__left__add">
              <div className="address__suggestion">
                <input
                  className="form__input-md"
                  type="text"
                  id="address"
                  placeholder="Start to type your address…"
                  disabled={BillingAddSame}
                  onKeyDown={handleKeyDown}
                  name="address"
                  onChange={HandleChange}
                  autocomplete="none"
                  value={Address1}
                />
                <ul className="suggestion__items">
                  {suggestionList !== [] &&
                    showSuggestions &&
                    renderSuggestions()}
                </ul>
              </div>
              {/* <input className="form__input-md" type="text" placeholder="Start to type your address…" disabled={BillingAddSame}
                            name="add_1" value={Address1} onChange={(event) => { setAddress1(event.target.value) }} required /> */}
              <div className="errors_container">
                <input
                  className="form__input-md"
                  type="text"
                  placeholder="Address Line 2"
                  name="add_2"
                  disabled={BillingAddSame}
                  value={Address2}
                  onChange={(event) => {
                    setAddress2(event.target.value);
                    validate();
                  }}
                />
                {errors.address2 ? (
                  <div className="errors" style={{ color: "red" }}>
                    * {errors.address2}
                  </div>
                ) : null}
              </div>

              <div className="errors_container">
                <input
                  className="form__input-md"
                  type="text"
                  placeholder="Town"
                  name="town"
                  disabled={BillingAddSame}
                  value={Town}
                  onChange={(event) => {
                    setTown(event.target.value);
                    validate();
                  }}
                />

                {errors.county ? (
                  <div className="errors" style={{ color: "red" }}>
                    * {errors.town}
                  </div>
                ) : null}
              </div>

              <div className="errors_container">
                <input
                  className="form__input-md"
                  type="text"
                  placeholder="County*"
                  disabled={BillingAddSame}
                  name="country"
                  value={County}
                  onChange={(event) => {
                    setCounty(event.target.value);
                    validate();
                  }}
                />

                {errors.county ? (
                  <div className="errors" style={{ color: "red" }}>
                    * {errors.county}
                  </div>
                ) : null}
              </div>

              <div className="errors_container">
                <input
                  className="form__input-md"
                  type="text"
                  placeholder="Postcode*"
                  disabled={BillingAddSame}
                  name="postcode"
                  value={PostCode}
                  onChange={(event) => {
                    setPostCode(event.target.value);
                    validate();
                  }}
                />

                {errors.postcode ? (
                  <div className="errors" style={{ color: "red" }}>
                    * {errors.postcode}
                  </div>
                ) : null}
              </div>
            </div>
            {/* <div className="cpay__box__left-paypal">
                            <div className="footer__nav-check">

                                <input type="radio" id="pay_agree_2" name="payment" value=""/>
                                <label htmlFor="pay_agree_2" className="checkmark_ft"></label>

                            </div>
                            <img src={require("../../assets/images/card/card_4.svg").default}
                                    alt=""/>
                        </div> */}
          </div>
          <div className="cpay__box__right">
            <h2 className="cpay__box__right-txt text-jost-sb-22">
              Payment Summary
            </h2>
            <div className="cpay__box__right__count">
              <div className="cpay__box__right__count-head">
                <h3 className="text-ops-sm-16">Item</h3>
                <h3 className="text-ops-sm-16">Monthly</h3>
                <h3 className="text-ops-sm-16">Annually</h3>
              </div>
              <div className="cpay__box__right__count-sec">
                {props.Data.users.map((data) => {
                  return (
                    <>
                      <p>{data.course_name}</p>
                      <span>
                        £
                        {subscription
                          ? subscription
                              .find((_s) => _s.id === 1)
                              .amount.toFixed(2)
                          : null}
                      </span>
                      <span>
                        £
                        {subscription
                          ? subscription
                              .find((_s) => _s.id === 2)
                              .amount.toFixed(2)
                          : null}
                      </span>
                    </>
                  );
                })}
              </div>
              <div className="cpay__box__right__count-total">
                <span className="text-ops-b-18">Total (includes VAT)</span>
                <span className="text-ops-b-18">
                  £
                  {subscription
                    ? (
                        subscription.find((_s) => _s.id === 1).amount *
                        props.Data.users.length
                      ).toFixed(2)
                    : null}
                </span>
                <span className="text-ops-b-18">
                  £
                  {subscription
                    ? (
                        subscription.find((_s) => _s.id === 2).amount *
                        props.Data.users.length
                      ).toFixed(2)
                    : null}
                </span>
              </div>
            </div>
            <h2 className="text-jost-sb-22">How would you like to pay?</h2>
            <div className="cpay__box__right__paywrap">
              <div
                className="cpay__box__right__paywrap-payop"
                onClick={(evnt) => {
                  setTotalAmountToPay({
                    amount: (
                      subscription.find((_s) => _s.id === 1).amount *
                      props.Data.users.length
                    ).toFixed(2),
                    type: "monthly",
                  });
                  setSubscriptionId("1");
                }}
              >
                <span>
                  {" "}
                  {TotalAmountToPay["type"] == "monthly"
                    ? `£${Number(TotalAmountToPay["amount"]).toFixed(2)}`
                    : ""}
                </span>
                <input
                  type="radio"
                  id="pay_month"
                  name="pay"
                  value="month"
                  checked={subscription_id === "1"}
                />

                <label htmlFor="pay_month">
                  <span className="text-jost-sb-22-wt">Pay Monthly</span>
                  <span className="text-jost-sb-22-wt">
                    £
                    {subscription
                      ? (
                          subscription.find((_s) => _s.id === 1).amount *
                          props.Data.users.length
                        ).toFixed(2)
                      : null}
                  </span>
                </label>
              </div>

              <div
                className="cpay__box__right__paywrap-payop"
                onClick={(evnt) => {
                  setTotalAmountToPay({
                    amount: (
                      subscription.find((_s) => _s.id === 2).amount *
                      props.Data.users.length
                    ).toFixed(2),
                    type: "yearly",
                  });
                  setSubscriptionId("2");
                }}
              >
                <span>
                  {" "}
                  {TotalAmountToPay["type"] == "yearly"
                    ? `£${Number(TotalAmountToPay["amount"]).toFixed(2)}`
                    : ""}
                </span>

                <input
                  type="radio"
                  id="pay_year"
                  name="pay"
                  value="year"
                  checked={subscription_id === "2"}
                />

                <label htmlFor="pay_year">
                  <div className="text-jost-sb-22-wt">Pay Annually</div>
                  <div className="text-jost-sb-22-wt">
                    £
                    {subscription
                      ? (
                          subscription.find((_s) => _s.id === 2).amount *
                          props.Data.users.length
                        ).toFixed(2)
                      : null}
                  </div>
                </label>
              </div>
            </div>
            {TotalAmountToPay && (
              <h2 className="text-jost-sb-22">
                Your Amount Bill : £
                {Number(TotalAmountToPay["amount"]).toFixed(2)} with{" "}
                {TotalAmountToPay["type"]} type subscription.{" "}
              </h2>
            )}

            {/* <AgrementModal  AgreementBTNprop={AgreementBTN}  setAgreementBTNprop={setAgreementBTN}   {...props}    /> */}

            <div className="errors_container">
              <span className="cpay__box__right-check">
                <input
                  type="checkbox"
                  id="check_pay"
                  name="check_pay"
                  checked={AgreementBTN}
                  onChange={(event) => {
                    setAgreementBTN(event.target.checked);
                  }}
                  style={{ backgroundColor: AgreementBTN ? "green" : "yellow" }}
                />
                <label
                  htmlFor="check_pay"
                  className={`checkbox ${AgreementBTN}-checked`}
                ></label>

                <span className="text-ops-rg-15-cap">
                  I Agree To Timely Golf’s{" "}
                  <a
                    className="text-ops-rg-15-cap"
                    href=""
                    onClick={(event) => {
                      event.preventDefault();
                      Toggle();
                    }}
                  >
                    Terms & Conditions
                  </a>{" "}
                </span>
                <Modal
                  show={modal}
                  title="TERMS FOR Timely Golf"
                  close={Toggle}
                >
                  <div dangerouslySetInnerHTML={{ __html: StaticTCAPIDATA }} />
                </Modal>
              </span>

              {errors.agreementBTN ? (
                <div className="errors" style={{ color: "red" }}>
                  * {errors.agreementBTN}
                </div>
              ) : null}
            </div>

            <div className="cpay-links">
              {/*<NavLink to="/pay-confirm" target="_self" className="res-btn-primary">Pay Now</NavLink> */}

              <button
                className="res-btn-ternary"
                onClick={(event) => {
                  if (props.renewPay) {
                    history.push("/billing");
                  } else {
                    history.push({ pathname: "/golf-courses" });
                  }
                }}
              >
                Back
              </button>

              <button
                type="submit"
                onClick={() => {
                  setSubmit(true);
                  validate();
                }}
                className="res-btn-primary"
              >
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};
export default CheckoutForm;
